// Keep frontend and backend versions in sync

/**
 * Calculate service fee for a given subtotal and fee config.
 * Returns { amount, platformShare, mallShare, feeType, label }.
 * Client-side version — PREVIEW ONLY. Server-side is authoritative.
 */
export function calculateServiceFee(subtotal, config) {
  if (!config || !config.enabled) return { amount: 0, platformShare: 0, mallShare: 0, feeType: null, label: 'Service Fee' };
  if (config.minOrderAmount && subtotal < config.minOrderAmount) {
    return { amount: 0, platformShare: 0, mallShare: 0, feeType: config.type, label: config.label || 'Service Fee' };
  }

  let fee = 0;
  if (config.type === 'FIXED') {
    fee = config.fixedAmount || 0;
  } else if (config.type === 'PERCENTAGE') {
    fee = subtotal * ((config.percentage || 0) / 100);
  } else if (config.type === 'HYBRID') {
    fee = (config.fixedAmount || 0) + subtotal * ((config.percentage || 0) / 100);
  }

  if (config.maxCap && config.maxCap > 0 && fee > config.maxCap) {
    fee = config.maxCap;
  }

  fee = Math.round(fee * 100) / 100;

  const platformPercent = config.platformSharePercent ?? 100;
  const mallPercent     = config.mallSharePercent     ?? 0;
  const mallShare          = Math.round(fee * mallPercent) / 100;
  const adjustedPlatformShare = fee - mallShare;

  return {
    amount:        fee,
    platformShare: Math.round(adjustedPlatformShare * 100) / 100,
    mallShare:     Math.round(mallShare * 100) / 100,
    feeType:       config.type,
    label:         config.label || 'Service Fee',
  };
}
